module.exports = __webpack_public_path__ + "static/media/24UHCHR7.6541747b.jpg";